import Index from "../../pages/ares/anniversary/index";
import Download from "../../pages/ares/anniversary/download";

const base = "anniversary";

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index,
  },
  {
    path: `/${base}/download`,
    name: `${base}-download`,
    component: Download,
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/ares/anniversary.js